export default __webpack_public_path__ + "static/media/trailer.03892580.mp4";